<template>
  <OptionsField v-bind="$attrs" type="radio">
    <slot name="default" />
  </OptionsField>
</template>

<script>
import OptionsField from 'Web/Form/Fields/OptionsField.vue';

export default {
  inheritAttrs: false,
  components: {
    OptionsField,
  },
}
</script>
